var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHairdresser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M22.053 20.198c-1.205-1.205-3.048-1.37-4.437-.512l-6.897-6.897V.829c0-.458-.372-.829-.83-.829-.458 0-.83.37-.83.83v10.3L1.417 3.486c-.324-.324-.85-.324-1.174 0-.324.324-.324.85 0 1.173l8.816 8.816v10.262c-1.589.377-2.775 1.796-2.775 3.5 0 1.991 1.614 3.605 3.605 3.605 1.991 0 3.606-1.614 3.606-3.605 0-1.704-1.187-3.123-2.776-3.5v-8.603l5.723 5.724c-.858 1.39-.693 3.232.512 4.437 1.409 1.408 3.691 1.408 5.099 0 1.407-1.407 1.407-3.69 0-5.098m-9.767 7.04c0 1.323-1.073 2.397-2.397 2.397-1.324 0-2.397-1.074-2.397-2.397 0-1.323 1.073-2.397 2.397-2.397 1.324 0 2.397 1.074 2.397 2.397m8.913-2.796c-.936.936-2.455.936-3.39 0-.937-.936-.937-2.454 0-3.39.935-.936 2.454-.936 3.39 0 .936.936.936 2.454 0 3.39",
    transform: "translate(.66 .568)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M10.387 13.161c0 .29-.236.527-.526.527-.291 0-.527-.236-.527-.527 0-.29.236-.526.527-.526.29 0 .526.236.526.526",
    transform: "translate(.66 .568)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairdresser);
export default __webpack_public_path__ + "static/media/hairdresser.a934732325266a764291a22bef43cf63.svg";
export { ForwardRef as ReactComponent };